import { AppUtil } from 'kuaidong-lib'
import { ITeacherAddressInfoForm } from 'kuaidong-model'

// 获取学校物流地址
export function getPhysicalConfirmSchoolAddress() {
  return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/motivation/physical_confirmation/school_address`)
}

// 更新学校物流地址
export function updatePhysicalConfirmSchoolAddress(data: ITeacherAddressInfoForm) {
  return AppUtil.httpPOST(
    `${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/motivation/physical_confirmation/school_address/update`,
    data
  )
}
